import { render, staticRenderFns } from "./PxbmBrowse.vue?vue&type=template&id=74e21a14"
import script from "./PxbmBrowse.vue?vue&type=script&lang=js"
export * from "./PxbmBrowse.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports